import { render, staticRenderFns } from "./RelatedStyles.vue?vue&type=template&id=1929245a&"
import script from "./RelatedStyles.vue?vue&type=script&lang=js&"
export * from "./RelatedStyles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedStyles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports